export const hotComics = [
  {
    id: 1,
    slug: 'wo-du-zi-sheng-ji',
    title: '我独自升级',
    author: 'Chugong / Jang Sung-rak',
    rating: 9.7,
    category: '动作',
    tags: ['奇幻', '热血', '系统'],
    status: '已完结',
    chapters: 179,
    description: '在一个连接异次元的"门"出现的世界，觉醒者猎人程肖宇从"最弱猎人"一步步进化为最强存在。精美的画风与爽快的战斗场面，让这部作品成为全球现象级韩漫。',
    coverSeq: 'solo-leveling-cover-01',
    coverQuery: 'Solo%20leveling%20manhwa%20cover%20style%2C%20dark%20fantasy%20warrior%20with%20glowing%20eyes%20in%20epic%20battle%20pose%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20Korean%20webtoon%20art%20style%2C%20warm%20dark%20tones',
  },
  {
    id: 2,
    slug: 'nv-shen-jiang-lin',
    title: '女神降临',
    author: 'Yaongyi',
    rating: 9.5,
    category: '恋爱',
    tags: ['校园', '美妆', '喜剧'],
    status: '已完结',
    chapters: 226,
    description: '因外貌自卑的女孩通过化妆技巧蜕变为校园女神，在两个完美男神之间展开了一段甜蜜又纠结的三角恋。画风绝美，剧情治愈又搞笑。',
    coverSeq: 'true-beauty-cover-02',
    coverQuery: 'True%20Beauty%20manhwa%20cover%20style%2C%20beautiful%20Korean%20girl%20with%20makeup%20transformation%2C%20soft%20romantic%20atmosphere%2C%20pastel%20color%20palette%2C%20Korean%20webtoon%20art%20style%2C%20gentle%20warm%20lighting',
  },
  {
    id: 3,
    slug: 'quan-zhi-du-zhe-shi-jiao',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    rating: 9.6,
    category: '奇幻',
    tags: ['末世', '系统', '智斗'],
    status: '连载中',
    chapters: 210,
    description: '金独子是唯一读完长达3149话网络小说的人，当小说中的末日场景在现实中上演，他凭借全知视角在这末世中艰难求生。',
    coverSeq: 'omniscient-reader-cover-03',
    coverQuery: 'Omniscient%20reader%20manhwa%20cover%20style%2C%20apocalyptic%20fantasy%20scene%20with%20mysterious%20protagonist%2C%20dramatic%20atmosphere%2C%20cosmic%20elements%2C%20Korean%20webtoon%20art%20style%2C%20dark%20warm%20undertones',
  },
  {
    id: 4,
    slug: 'gong-jue-qi-yue-hun-qi',
    title: '公爵的契约未婚妻',
    author: 'Milcha / Whale',
    rating: 9.3,
    category: '恋爱',
    tags: ['穿越', '宫廷', '契约'],
    status: '连载中',
    chapters: 158,
    description: '穿越成为小说中即将被抛弃的配角，为了活下去，她向冷血公爵提出了契约婚约。一场各取所需的交易，却意外擦出爱的火花。',
    coverSeq: 'duke-contract-cover-04',
    coverQuery: 'Romance%20fantasy%20manhwa%20cover%2C%20elegant%20duke%20and%20beautiful%20lady%20in%20royal%20setting%2C%20contract%20marriage%20theme%2C%20lavish%20gown%2C%20Korean%20webtoon%20art%20style%2C%20warm%20golden%20light',
  },
  {
    id: 5,
    slug: 'e-nv-shi-ti-xian-mu-ou',
    title: '恶女是提线木偶',
    author: 'Hanirim / Manggle',
    rating: 9.4,
    category: '剧情',
    tags: ['重生', '宫廷', '权谋'],
    status: '连载中',
    chapters: 132,
    description: '被最信任的人背叛而死，重生归来后的帝国皇女凯耶娜决心不再做任何人的提线木偶，她要亲手掌控自己的命运。',
    coverSeq: 'villainess-puppet-cover-05',
    coverQuery: 'Villainess%20manhwa%20cover%2C%20elegant%20dark-haired%20princess%20in%20royal%20palace%2C%20string%20puppet%20theme%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20art%20style%2C%20rich%20dark%20warm%20colors',
  },
  {
    id: 6,
    slug: 'jian-zun-gui-lai',
    title: '剑尊归来',
    author: 'Biga / LICO',
    rating: 9.8,
    category: '动作',
    tags: ['武侠', '重生', '热血'],
    status: '连载中',
    chapters: 186,
    description: '一代剑尊在修炼巅峰陨落后重生到现代，以无敌剑术横扫各路强者。华丽的剑技与热血的战斗，让人热血沸腾。',
    coverSeq: 'sword-emperor-return-cover-06',
    coverQuery: 'Martial%20arts%20manhwa%20cover%2C%20sword%20master%20in%20dynamic%20fighting%20pose%2C%20ancient%20Chinese%20martial%20arts%20aesthetic%2C%20dramatic%20energy%20effects%2C%20Korean%20webtoon%20art%20style%2C%20warm%20fiery%20tones',
  },
];

export const categories = [
  { id: 1, slug: 'lian-ai', name: '恋爱', count: 2530, color: 'from-rose-300/40 via-rose-200/30 to-rose-100/20' },
  { id: 2, slug: 'qi-huan', name: '奇幻', count: 1890, color: 'from-emerald-300/40 via-emerald-200/30 to-emerald-100/20' },
  { id: 3, slug: 'dong-zuo', name: '动作', count: 1620, color: 'from-amber-300/40 via-amber-200/30 to-amber-100/20' },
  { id: 4, slug: 'ju-qing', name: '剧情', count: 1410, color: 'from-stone-300/40 via-stone-200/30 to-stone-100/20' },
  { id: 5, slug: 'chong-sheng', name: '重生', count: 1150, color: 'from-fuchsia-300/40 via-fuchsia-200/30 to-fuchsia-100/20' },
  { id: 6, slug: 'gao-xiao', name: '搞笑', count: 980, color: 'from-cyan-300/40 via-cyan-200/30 to-cyan-100/20' },
  { id: 7, slug: 'xuan-yi', name: '悬疑', count: 760, color: 'from-indigo-300/40 via-indigo-200/30 to-indigo-100/20' },
  { id: 8, slug: 'gu-feng', name: '古风', count: 640, color: 'from-orange-300/40 via-orange-200/30 to-orange-100/20' },
];

export const testimonials = [
  {
    id: 1,
    name: '漫画迷小月',
    role: '资深韩漫读者',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%2C%20soft%20pastel%20colors%2C%20simple%20clean%20background%2C%20Korean%20webtoon%20style%20portrait&width=80&height=80&seq=avatar-user-01&orientation=squarish',
    rating: 5,
    title: '画质超清晰，下拉式阅读太方便了',
    content: '在51漫画网看韩漫已经两年了，画质真的很清晰，完全没有删减！下拉式的阅读方式非常流畅，不用翻页，一口气看几十话都不觉得累。推荐给了好多朋友！',
  },
  {
    id: 2,
    name: '二次元阿杰',
    role: '漫画博主',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20boy%20avatar%20portrait%2C%20cool%20casual%20look%2C%20simple%20clean%20background%2C%20Korean%20webtoon%20style&width=80&height=80&seq=avatar-user-02&orientation=squarish',
    rating: 5,
    title: '更新速度很快，资源非常全',
    content: '做漫画推荐博主最需要的就是资源全面和更新及时，51漫画网完全满足了我的需求。热门韩漫基本都有，而且更新跟进很快，是我每天必刷的网站。',
  },
  {
    id: 3,
    name: '熬夜看漫',
    role: '忠实用户3年',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20woman%20avatar%2C%20warm%20smile%2C%20casual%20style%2C%20simple%20clean%20background%2C%20Korean%20webtoon%20style%20portrait&width=80&height=80&seq=avatar-user-03&orientation=squarish',
    rating: 5,
    title: '界面简洁，分类很清晰',
    content: '最让我喜欢的是分类系统，恋爱、奇幻、动作一目了然。而且网站界面很清爽，没有乱七八糟的广告弹窗，阅读体验非常好。免费韩漫大全真不是白叫的！',
  },
  {
    id: 4,
    name: '漫无止境',
    role: '上班族漫友',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20office%20worker%20avatar%2C%20gentle%20expression%2C%20simple%20clean%20background%2C%20Korean%20webtoon%20style%20portrait&width=80&height=80&seq=avatar-user-04&orientation=squarish',
    rating: 4,
    title: '通勤路上的最佳伴侣',
    content: '每天上下班地铁上就看51漫画网，下拉式阅读单手操作特别方便。无删减的内容看着就是过瘾，剧情完整不跳戏，强烈推荐给同样通勤看漫的朋友。',
  },
  {
    id: 5,
    name: '冷月如霜',
    role: '恋爱漫画爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20gentle%20girl%20avatar%2C%20soft%20expression%2C%20simple%20clean%20background%2C%20Korean%20webtoon%20style%20portrait&width=80&height=80&seq=avatar-user-05&orientation=squarish',
    rating: 5,
    title: '恋爱漫画资源太丰富了',
    content: '作为一个重度恋爱韩漫爱好者，51漫画网的恋爱分类简直是我的天堂！从宫廷到校园、从穿越到重生，各种题材应有尽有，每一部都让人上头！',
  },
  {
    id: 6,
    name: '热血漫魂',
    role: '动作漫画铁粉',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20cool%20guy%20avatar%2C%20confident%20expression%2C%20simple%20clean%20background%2C%20Korean%20webtoon%20style%20portrait&width=80&height=80&seq=avatar-user-06&orientation=squarish',
    rating: 5,
    title: '我独自升级追完了，太过瘾',
    content: '从《我独自升级》入坑，到现在每天都要来51漫画网刷更新。动作类韩漫画风和分镜真的绝了，感谢平台提供这么高质量的免费阅读体验！',
  },
];

export const siteInfo = {
  name: '51漫画网',
  slogan: '免费韩漫大全，下拉式高效阅读',
  description: '51漫画网提供无删减韩国漫画下拉式阅读服务，免费韩漫大全题材丰富多样，更新及时、资源优质，为您打造便捷高效的韩漫阅读平台。',
  established: 2018,
  stats: [
    { label: '海量资源', value: '10,000+', desc: '持续更新的韩漫资源库' },
    { label: '高清画质', value: '4K', desc: '极致清晰的阅读体验' },
    { label: '每日更新', value: '50+', desc: '追更不停歇的更新速度' },
    { label: '忠实用户', value: '500万+', desc: '值得信赖的漫友选择' },
  ],
};